.tag-age-label {
  font-size: 10px;
}
